import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5e9a6080"
import script from "./invoiceApprovalDetails.js?vue&type=script&lang=js&external"
export * from "./invoiceApprovalDetails.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=5e9a6080&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports